import { Component, OnInit } from '@angular/core';
import {Router } from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, FormArray, Validators} from '@angular/forms';
import { MembershipPaymentService } from '../services/membership-payment.service';

declare var App;
declare var Encrypter: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  isLoading1: boolean = false;
  isLoading2: boolean = false;
  public signIn: boolean  = true;
  public signupForm: any;
  public formSubmit: boolean = false;
  public formInSubmit: boolean = false
  public formForgotSubmit: boolean = false;
  public signinForm: any;
  public forgotForm: any;
  public emailexist: boolean = false;
  public invalidLogin: boolean = false;
  public forgotPassword: boolean = false;
  public success: boolean = false;
  constructor(private route: Router, 
              private _formBuilder: FormBuilder,
              private m_pService: MembershipPaymentService) {
      if(App.plan_data && App.user_details.id) {
        window.location.href= App.base_url + "membershipPayment";      
      }
     }

  public googleIcon = App.public_url + 'telemedicine/assets/images/google.svg';
  public facebookIcon = App.public_url + 'telemedicine/assets/images/facebook.svg';
 
  public coloredlogo = App.public_url + 'telemedicine/assets/images/coloredlogo1.svg';
  public userIcon = App.public_url + 'telemedicine/assets/images/user_avatar.svg';
  public successIcon = App.public_url + 'telemedicine/assets/images/Tick.svg';

  ngOnInit() {
    console.log(App)

    this.signupForm = this._formBuilder.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      user_email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      c_password: [''],
      time_zone: new Date().getTimezoneOffset()
    }, {validator: this.checkPasswords })
    this.signinForm = this._formBuilder.group({
      username: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      time_zone: new Date().getTimezoneOffset()
    })
    this.forgotForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
    })

  }

  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    let pass = group.get('password').value;
    let confirmPass = group.get('c_password').value;

    return pass === confirmPass ? null : { notSame: true }     
  }
  public goTo(name) {
    if(name == 'google'){
        window.location.href= App.base_url + "redirect";
        this.isLoading2 = false;
        this.isLoading1 = true;

      // return;
      // if(!App.plan_data) {
      //     this.goToPage('telemedicine')
      // }
    }
    if(name == 'facebook'){
        window.location.href= App.base_url + "fbredirect";
        this.isLoading1 = false;
        this.isLoading2 = true;
      // if(!App.plan_data) {
      //     this.goToPage('telemedicine')
      // }
    }
  }


  goToPage(event, userId = 0){

    var newForm = document.createElement('form');
    newForm.setAttribute('id', 'newForm');
    newForm.setAttribute('method', 'post');
    newForm.setAttribute('action', App.froent_end_url + event);

    var hidden_user = document.createElement("input");
    hidden_user.type = "hidden";
    hidden_user.id = "userId";
    hidden_user.name = "userId";
    hidden_user.value = App.user_details.id ? App.user_details.id : userId;
    var hidden_flag = document.createElement("input");
    hidden_flag.type = "hidden";
    hidden_flag.id = "nav_flag";
    hidden_flag.name = "nav_flag";
    hidden_flag.value = "true";

    newForm.appendChild(hidden_user);
    newForm.appendChild(hidden_flag);

    document.body.appendChild(newForm);

    newForm.submit();
  }

  ontyped() {
    this.invalidLogin = false;
    this.emailexist = false;
  }
  signUpSubmit() {
    console.log(this.signupForm)
    this.formSubmit = true;
    if (this.signupForm.invalid) {
      return;
    }
    if(this.signupForm.value.user_email && this.signupForm.value.password && this.signupForm.value.c_password && (this.signupForm.value.password === this.signupForm.value.c_password)){ 
      this.signupForm.value.sd_capabilities = "customer";
      this.signupForm.value.user_role = "customer";
      this.signupForm.value.plan_data = App.plan_data;
      this.m_pService.signUpApi(this.signupForm.value).subscribe(response => {
        // console.log(response);
        if (response.result.success) {
          // this.m_pService.checkUserExistingPlans({plan_id:App.plan_data.plan_id}).subscribe(response => {
          //   console.log(response);
          // })

          this.emailexist = false;
              console.log(App);
          if(App.plan_data == null && App.user_details) {
            this.goToPage('telemedicine', response.result.data.user_id)
          }
          if(App.plan_data && App.user_details){

            window.location.href= App.base_url + "membershipPayment";
          }
        } else {
          this.emailexist = true;
        }
      }) 
    }else{
      // alert()
    }
    // console.log(this.signupForm, App.base_url + "membershipPayment");
  }

  signInSubmit() {
    console.log
    this.formInSubmit = true;
    if (this.signinForm.invalid) {
        return;
     }
        if(!this.signinForm.value.username && !this.signinForm.value.password){ 
          return; 
        }else{
          var rsaEncrypter = new Encrypter("BD20872ADB5595CCC9EC9060FC7B588243236358387C841912BE5E70EEE61D9CC5A8F21D52489CC26793A3EB2A87E3BD5A0150DBEF8B07C1D423F4B94626166FD2BBE9EB41DBD712D7A492E582A5DC39DD5BF474198E092D15E32D663DF4AF64C86150EDA22AB6D121CF18A158A12F8D18E180BE3C0CA32A19111934EB54B835767BCA25A42C33613837FDDF0A32D258332A5D14A563399CBA79206B5EE5F78DE1A3368ECEA4CFBD024F1DEF57E46E81183B177B1A83AF96A417EBB8C3A75C4CD005B0C73E7E355D7B800C6C06AF154AE8A9D72F0B5F98A46756FB126956AF86A14EAD85E1706E4F9A65F3AB58D34462031C9020EF13410B070216720A47C773", "10001");
          this.signinForm.value.password = rsaEncrypter.encrypt(this.signinForm.value.password);
          this.signinForm.value.plan_data = App.plan_data;
          // this.signinForm.value.username = this.signinForm.value.email;


          this.m_pService.signInApi(this.signinForm.value).subscribe(response => {
            // console.log(response)
            // return;
            if (response.result.success) {
                  console.log(App)
              this.invalidLogin = false;
              if(!App.plan_data && App.user_details) {
                this.goToPage('telemedicine', response.result.data.user_id)
              }else {
                window.location.href= App.base_url + "membershipPayment";
              }
            } else {
              console.log(App)
              this.invalidLogin = true;
            }
          })
        }
      // }
  }

  forgotSubmit() {
    this.successIcon = '';
    this.formForgotSubmit = true;
    if (this.forgotForm.invalid) {
        return;
     }
    if(!this.forgotForm.value.email){ 
      return; 
    }else{
    this.m_pService.forgotPassword(this.forgotForm.value).subscribe(response => {
        if (response.result.success){
          this.success = true;
          this.forgotPassword = false;
          this.successIcon = App.public_url + 'telemedicine/assets/images/Tick.svg';
        }else{
          return;
          this.success = false;
        }
      })
    }
  }
}
